__turbopack_context__.v({
  "item": "A66-wa_item",
  "selected": "A66-wa_selected",
});
